import createIcon from '../../createIcon';

/**
 * @component @name Looks3
 * @description Google Material SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNMTkgM0g1QzMuOSAzIDMgMy45IDMgNVYxOUMzIDIwLjEgMy45IDIxIDUgMjFIMTlDMjAuMSAyMSAyMSAyMC4xIDIxIDE5VjVDMjEgMy45IDIwLjEgMyAxOSAzWk0xNSAxMC41QzE1IDExLjMzIDE0LjMzIDEyIDEzLjUgMTJDMTQuMzMgMTIgMTUgMTIuNjcgMTUgMTMuNVYxNUMxNSAxNi4xMSAxNC4xIDE3IDEzIDE3SDlWMTVIMTNWMTNIMTFWMTFIMTNWOUg5VjdIMTNDMTQuMSA3IDE1IDcuODkgMTUgOVYxMC41WiIgZmlsbD0iYmxhY2siLz4KPC9zdmc+Cg==)
 *
 * @param {Object} props - Google Material icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const Looks3 = createIcon('Looks3', [
  [
    'path',
    {
      d: 'M19 3H5C3.9 3 3 3.9 3 5V19C3 20.1 3.9 21 5 21H19C20.1 21 21 20.1 21 19V5C21 3.9 20.1 3 19 3ZM15 10.5C15 11.33 14.33 12 13.5 12C14.33 12 15 12.67 15 13.5V15C15 16.11 14.1 17 13 17H9V15H13V13H11V11H13V9H9V7H13C14.1 7 15 7.89 15 9V10.5Z',
      key: '10pchq',
    },
  ],
]);

export default Looks3;
